import {extractSystemMessage} from "../helpers/extract-system-message";

export function GetFormattedChatMessageForKeyType(t, content) {
	if (!t || !content) {
		console.error('error in getFormattedChatMessageForKeyType not enough params');
		return '';
	};

	if (typeof content !== 'string' || !extractSystemMessage(content)) {
		return content;
	}

	const system_message = extractSystemMessage(content);
	let parsed_system_message = undefined;
	try {
		parsed_system_message = JSON?.parse(extractSystemMessage(content));
	} catch (e) {

	}

	if (system_message === 'request_for_editing_post'){
		return t(`system_messages.${extractSystemMessage(content)}`);
	}

	if (parsed_system_message?.type === 'request_for_editing_post_with_info'){
		return t(`system_messages.${parsed_system_message?.type}`, {postNumber: parsed_system_message?.postCount, text: parsed_system_message?.message});
	}
	//
	// let sys_msg = '';
	// let parsedContent = '';
	// try {
	// 	sys_msg = JSON?.parse(extractSystemMessage(content));
	// 	parsedContent =
	// 			t(`system_messages.${sys_msg?.type}`, {postNumber: sys_msg?.postCount, text: sys_msg?.message});
	// } catch {
	//
	// }
	return content;
}